import { ThemeMode } from '../types/enums';

export const METRIC_EVENT_NAMES = {
  SIGN_IN: 'sign_in',
  SIGN_IN_OKTA: 'sign_in_okta',
  SIGN_IN_GOOGLE: 'sign_in_google',
  CREATE_NEW_PROFILE: 'create_new_profile',
  FORGOT_PASSWORD: 'forgot_password',
  RESET_PASSWORD: 'reset_password',
  SIGN_UP_GOOGLE: 'sign_up_google',
  SIGN_UP_GOOGLE_INVITE: 'sign_up_google_invite',
  SIGN_UP: 'sign_up',
  SIGN_UP_INVITE: 'sign_up_invite',
  CONTACT_US: 'contact_us',
  TERMS: 'terms',
  PRIVACY_POLICY: 'privacy_policy',
  LOGIN: 'user_login',
  LOGOUT: 'user_logout',
  THEME_MODE: (mode: ThemeMode) => `theme_mode_${mode}`,
}

export const CATEGORY_NAMES = {
  PUBTOOL_EVENTS: 'pubtool-events'
}
